import { DetailPhysicalAddress, HttpError } from '@rd/types';
import {
  PhysicalAddressActions,
  PhysicalAddressActionTypes,
} from '../actions/physical-address.actions';

export interface DetailAddressState {
  detailAddress: DetailPhysicalAddress | null;
  error: HttpError | null;
  loading: boolean;
}

const initialState: DetailAddressState = {
  detailAddress: null,
  error: null,
  loading: false,
};

export function detailAddressReducer(
  state: DetailAddressState = initialState,
  action: PhysicalAddressActions,
): DetailAddressState {
  switch (action.type) {
    case PhysicalAddressActionTypes.LOAD_DETAIL_ADDRESS:
      return {
        ...state,
        detailAddress: null,
        error: null,
        loading: true,
      };

    case PhysicalAddressActionTypes.LOAD_DETAIL_ADDRESS_SUCCESS:
      return {
        ...state,
        detailAddress: action.payload,
        error: null,
        loading: false,
      };

    case PhysicalAddressActionTypes.LOAD_DETAIL_ADDRESS_FAILED:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case PhysicalAddressActionTypes.UPDATE_DETAIL_ADDRESS:
      return {
        ...state,
        detailAddress: action.payload,
      };

    default:
      return state;
  }
}
